import lobbyDashboardConfigReducer from './lobbyDashboardConfigReducer'
import lobbyLoginConfigReducer from './lobbyLoginConfigReducer'
import windowMessagingReducer from './windowMessagingReducer'
import interactableReducer from './interactableReducer'
import patientDisplayReducer from './patientDisplayReducer'
import nurseDashboardReducer from './nurseDashboardReducer'
import lobbyDashboardReducer from './lobbyDashboardReducer'
import adminDisplayReducer from './adminDisplayReducer'
import lobbyLoginReducer from './lobbyLoginReducer'
import userConfigReducer from './userConfigReducer'
import appConfigReducer from './appConfigReducer'
import identityReducer from './identityReducer'
import { combineReducers } from 'redux'
import clockReducer from './clockReducer'
import locksReducer from './locksReducer'
import authReducer from './authReducer'
import logReducer from './logReducer'
import modalReducer from './modalReducer'
import streamReducer from './streamReducer'
import statePersistanceWrapper from 'Helper/statePersistanceWrapper'
import { persistedSliceReplacers } from './persistedSlices'
import xstdwReducer from './xstdwReducer'
import timerReducer from './timerReducer'
import routerReducer from './routerReducer'
import userReducer from './userReducer'
import apiReducer from './apiReducer'

const rootReducer = combineReducers({
  streams: streamReducer,
  router: routerReducer,
  lobbyDashboardConfig: lobbyDashboardConfigReducer,
  interactableState: statePersistanceWrapper(
    'interactableState',
    interactableReducer,
    persistedSliceReplacers.interactableState
  ),
  lobbyLoginConfig: lobbyLoginConfigReducer,
  windowMessaging: windowMessagingReducer,
  userConfig: userConfigReducer,
  patientDisplay: patientDisplayReducer,
  nurseDashboard: nurseDashboardReducer,
  lobbyDashboard: lobbyDashboardReducer,
  lobbyLogin: lobbyLoginReducer,
  adminDisplay: adminDisplayReducer,
  appConfig: statePersistanceWrapper(
    'appConfig',
    appConfigReducer,
    persistedSliceReplacers.appConfig
  ),
  identity: identityReducer,
  clock: statePersistanceWrapper(
    'clock',
    clockReducer,
    persistedSliceReplacers.clock
  ),
  locks: locksReducer,
  modal: modalReducer,
  auth: authReducer,
  log: logReducer,
  xstdw: xstdwReducer,
  timer: timerReducer,
  user: userReducer,
  api: apiReducer
})

export default rootReducer
